// extracted by mini-css-extract-plugin
export default {"surface":"CustomViewContainer_surface__v+i5C"};